export const setDocumentTitle = title => {
  document.title = title;
};
